/** The skill effects (render/effects.ts): those on the ground under the figures, the rest over them. */
import { settings } from '../../settings';
import { fxPixelOn, fxPixelWanted, PixelPen, setFxPixel } from '../fx/pixelRules';
import { registerRenderPass } from './registry';

// FX-PIXEL (fx/pixelRules.ts): the effects draw through a pixel pen (scene grid, master-palette ramps, dither,
// outline) unless the `fxPixel` setting is off.
const groundPen = new PixelPen();
const worldPen = new PixelPen();

registerRenderPass({
  id: 'groundEffects',
  layer: 'ground',
  // After the turned ground (turnGroundEnd, 900): effects are pushed in screen coordinates (turned already), so
  // drawing them inside the turn would turn them twice (the ink/sword ground halves, snowblink's frost sheets).
  order: 910,
  draw(f) {
    setFxPixel(fxPixelWanted(settings.fxPixel));
    if (!fxPixelOn()) {
      f.effects.drawGround(f.g, f.ox, f.oy);
      return;
    }
    f.g.save();
    f.effects.drawGround(groundPen.begin(f.g), f.ox, f.oy);
    groundPen.end();
    f.g.restore();
  },
});

registerRenderPass({
  id: 'effects',
  layer: 'world',
  order: 300,
  draw(f) {
    if (!fxPixelOn()) {
      f.effects.draw(f.g, f.ox, f.oy);
      return;
    }
    f.g.save();
    f.effects.draw(worldPen.begin(f.g), f.ox, f.oy);
    worldPen.end();
    f.g.restore();
  },
});
